export enum REMINDER_STATUS {
  UNSATISFIED = 'UNSATISFIED',
  UNKNOWN = 'UNKNOWN',
  EXCLUDED = 'EXCLUDED',
  SATISFIED = 'SATISFIED',
  REJECTED = 'REJECTED',
  ACCEPTED = 'ACCEPTED',
}

export enum REMINDER_AVAILABILITY {
  AVAILABLE = 'AVAILABLE',
  SEEN = 'SEEN',
  NO_DATA = 'NO_DATA',
}

export enum REMINDER_GROUP_TYPE {
  NEEDS_RESPONSE = 'NEEDS_RESPONSE',
  CHECK_BOX = 'CHECK_BOX',
}
